import React from "react";
import { BarChart, Bar, XAxis, Tooltip, ResponsiveContainer } from "recharts";
import { Box, Paper, Typography } from "@mui/material";
import useMode from "hooks/useMode";

// const data = [
//   { area: "Mo", quantity: 1100 },
//   { area: "Tu", quantity: 1300 },
//   { area: "We", quantity: 950 },
//   { area: "Th", quantity: 600 },
//   { area: "Fr", quantity: 850 },
//   { area: "Sa", quantity: 740 },
//   { area: "Su", quantity: 1100 },
// ];

const IncomeOverviewChart = ({ data }) => {
  const mode = useMode()
  return (
    <Paper sx={{ p: 2, minHeight: 367, justifyContent: 'space-between', backgroundColor: mode.third }}>
      <Typography variant="h6" gutterBottom>
        地域別グラフ
      </Typography>
      {/* <Typography variant="h4" sx={{ mb: 2 }}>
      {' '}
    </Typography> */}
      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={data}>
          <XAxis dataKey="area" />
          <Tooltip />
          <Bar dataKey="quantity" fill="#00C49F" radius={[5, 5, 0, 0]} />

        </BarChart>
      </ResponsiveContainer>
    </Paper>
  )
};

export default IncomeOverviewChart;
